export const getTrainings = (values)=>(
    {
      nivel_educativo_alcanzado: values.formación.id,
      formacion_areas_artisticas: values.formaciónAreaArtística.id,
      otra_area_formacion: values.formaciónAreaArtística.id == 96 ? values?.otraFormaciónArtística : null,

      portador_manifestaciones_tradicionales: null,
      oficios_tradicionales: null,
      otra: null,
      tiempo_dedicado_formacion: values.tiempoActividadMeses || null
    }
)

export const getUpdateTrainings = (values)=>(
  {
    persona: localStorage.getItem('persona_id'),
    nivel_educativo_alcanzado: values.formación.id,
    formacion_areas_artisticas: values.formaciónAreaArtística.id,
    otra_area_formacion: values.formaciónAreaArtística.id == 96 ? values?.otraFormaciónArtística : null,

    portador_manifestaciones_tradicionales: null,
    oficios_tradicionales: null,
    otra: null,
    tiempo_dedicado_formacion: null
  }
)

export const getArtisticExp = (values) => (
    {
        principal_actividad_creacion: values.actividadArtística.id,
        principal_otra_disciplina_produccion_artistica: values.actividadArtística.id == 96 ? values.otraActividad : null,
        tiempo_dedicado_actividad: parseInt(values?.tiempoActividadAños * 12 || 0 ) + parseInt(values?.tiempoActividadMeses || 0),
        desempena_actividad_actualmente: values.desempeñaActividad.id,
        otra_disciplina_produccion_artistica: values.desempeñaActividad.id == 31 ? values.cualDesempeña : null,

        actividad_cultural_desempena: values.actividadArtística.id,
        
        portador_manifestaciones_patrimonio: null,
        oficios_tradicionales: null,
        otra: null,
    }
)

export const getUpdateArtisticExp = (values) => (
  {
      principal_actividad_creacion: values.actividadArtística.id,
      principal_otra_disciplina_produccion_artistica: values.actividadArtística.id == 96 ? values.otraActividad : null,
      tiempo_dedicado_actividad: parseInt(values?.tiempoActividadAños * 12 || 0 ) + parseInt(values?.tiempoActividadMeses || 0),
      desempena_actividad_actualmente: values.desempeñaActividad.id,
      otra_disciplina_produccion_artistica: values.desempeñaActividad.id == 31 ? values.cualDesempeña : null,

      actividad_cultural_desempena: values.actividadArtística.id,

      portador_manifestaciones_patrimonio: null,
      oficios_tradicionales: null,
      otra: null,
  }
)
export const getTrainingList = (values) => {
  const trainingList = [
      {
        area_formacion:  values.areaFormación1,
        tiempo_cursado:  values.tiempoCursado1,
        titulo_obtenido: values.tituloObtenido1
      },
      {
        area_formacion:  values.areaFormación2,
        tiempo_cursado:  values.tiempoCursado2,
        titulo_obtenido: values.tituloObtenido2
      },
      {
        area_formacion:  values.areaFormación3,
        tiempo_cursado:  values.tiempoCursado3,
        titulo_obtenido: values.tituloObtenido3
      },
      {
        area_formacion:  values.areaFormación4,
        tiempo_cursado:  values.tiempoCursado4,
        titulo_obtenido: values.tituloObtenido4
      }
    ] 
    const trainingsActive = trainingList.filter(item => item.area_formacion)
    return trainingsActive
}
export const getUpdateTrainingList = (values) => {
    const trainingList = [
        {
          id: values.idFormacion1,
          area_formacion:  values.areaFormación1,
          tiempo_cursado:  values.tiempoCursado1,
          titulo_obtenido: values.tituloObtenido1,
          persona: localStorage.getItem('persona_id'),
        },
        {
          id: values.idFormacion2,
          area_formacion:  values.areaFormación2,
          tiempo_cursado:  values.tiempoCursado2,
          titulo_obtenido: values.tituloObtenido2,
          persona: localStorage.getItem('persona_id'),
        },
        {
          id: values.idFormacion3,
          area_formacion:  values.areaFormación3,
          tiempo_cursado:  values.tiempoCursado3,
          titulo_obtenido: values.tituloObtenido3,
          persona: localStorage.getItem('persona_id'),
        },
        {
          id: values.idFormacion4,
          area_formacion:  values.areaFormación4,
          tiempo_cursado:  values.tiempoCursado4,
          titulo_obtenido: values.tituloObtenido4,
          persona: localStorage.getItem('persona_id'),
        }
      ] 
      const trainingsActive = trainingList.filter(item => item.area_formacion)
      return trainingsActive
}

